
import { Avatar, Button, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Resizer from "react-image-file-resizer";
import ImageUploading from "react-images-uploading";
import ImageUploadIcon from "../../Assets/Icons/ImageUpload.svg";
import { ApiContext } from "../ApiContext";
import { SnackContext } from "../SnackContext";
import { UserContext } from "../UserContext";

export const ImageUpload = ({
	imageType,
	oldImage,
}) => {
	const debug = false;
	const [newImage, setNewImage] = useState(false);
	const [images, setImages] = useState([]);
	const [maxNumber, setMaxNumber] = useState("");
	const [imageTypeNum, setImageTypeNum] = useState("");

	const { selectedLocation } = useContext(UserContext);

	const { setOpenSnack, setGetSeverity, setSnackMessage } =
		useContext(SnackContext);

	const { ApiCall } = useContext(ApiContext);
	const { t } = useTranslation();

	function urltoFile(url, filename, mimeType) {
		return fetch(url)
			.then((res) => res.arrayBuffer())
			.then((buf) => new File([buf], filename, { type: mimeType }));
	}

	const resizeFile = (file, size, type) =>
		new Promise((resolve) => {
			Resizer.imageFileResizer(
				file,
				size,
				size,
				type,
				100,
				0,
				(uri) => {
					resolve(uri);
				},
				"base64"
			);
		});

	const onChange = (imageList) => {
		setImages(imageList);
		setNewImage(true);

		handleUpload(imageList);
	};

	const handleUpload = (imageList) => {
		urltoFile(
			imageList[0].data_url,
			imageList[0].file.type + "",
			imageList[0].file.type + ""
		).then((res) => {
			let size =
				imageTypeNum === 1
					? 100
					: imageTypeNum === 2
						? 1000
						: imageTypeNum === 4
							? 600
							: imageTypeNum === 5
								? 300
								: imageTypeNum === 6
									? 300
									: 500;
			let type = imageList[0].file.type.substring(6).toUpperCase();
			resizeFile(res, size, type).then((res) => {
				const imageData = {
					image_type: imageTypeNum,
					image: res
				};

				ApiCall("POST", "client/image/" + selectedLocation.id, imageData).catch(
					(error) => {
						if (debug) console.log(error);
					}
				);
			});
		});
	};

	const imageSwitch = () => {
		switch (imageType) {
			case "logo":
				return oldImage?.image;

			case "banner":
				return oldImage?.image;

			default:
				return ImageUploadIcon;
		}
	};

	useEffect(() => {
		switch (imageType) {
			case "banner":
				setMaxNumber(1);
				setImageTypeNum(2);

				break;
			case "logo":
				setMaxNumber(1);
				setImageTypeNum(1);

				break;

			default:
				break;
		}
	}, []);

	return (
		<ImageUploading
			value={images}
			onChange={onChange}
			maxNumber={maxNumber}
			dataURLKey="data_url"
			acceptType={["jpg", "jpeg", "png"]}
		>
			{({
				imageList,
				onImageUpload,
				onImageUpdate,
				isDragging,
				dragProps,
				errors
			}) => {
				useEffect(() => {
					setGetSeverity("error");

					if (errors !== null) {
						if (errors.maxFileSize) setSnackMessage("maxFileSize");
						if (errors.acceptType) setSnackMessage("acceptType");
						if (errors.maxNumber) setSnackMessage("maxNumber");
						if (errors.resolution) setSnackMessage("resolution");

						setOpenSnack(true);
					}
				}, [errors]);

				return (
					<div className="upload__image-wrapper">
						<Stack
							direction="column"
							justifyContent="space-between"
							alignItems="flex-start"
						>
							<Button
								variant={
									imageType === "logo"
										? "logoUpload"
										: "bannerUpload"
								}
								style={
									(isDragging ? { color: ColorScheme.dangerPrimary} : undefined,
									{
										padding: "20px",
										height: "100%",
										width: "100%"
									})
								}
								onClick={
									newImage
										? () => onImageUpdate()
										: () => onImageUpload()
								}
								{...dragProps}
							>
								{imageList !== undefined &&
									imageList.map((image, index) => (
										<Avatar
											key={index}
											sx={{
												width: imageType
													? "100px"
													: "fit-content",
												height: "100%",
												borderRadius: 0,
												objectFit: "cover"
											}}
											src={image.data_url}
											alt=""
										/>
									))}

								{imageList.length === 0 &&
									oldImage?.length === 0 && (
										<Typography
											color={ColorScheme.black}
											fontWeight="600"
											textTransform={"none"} // required, otherwise text will be all uppercase
										>
											{t("images.add_new_image_guide")}
										</Typography>
									)}

								{imageType !== "other" &&
									images.length < maxNumber &&
									oldImage?.length !== 0 && (
										<Avatar
											sx={{
												width: "200px",
												height: "100%",
												borderRadius: 0,
												objectFit: "contain"
											}}
											src={imageSwitch()}
											alt=""
										/>
									)}
							</Button>
						</Stack>
					</div>
				);
			}}
		</ImageUploading>
	);
};
